<template>
  <br>
  <br>
  <br>

  <v-icon
      class="mb-5"
      color="amber-lighten-3"
      icon="mdi-close-circle-outline"
      size="112"
  ></v-icon>
  <br>
  <v-card-title>Что-то пошло не так</v-card-title>

  <v-sheet width="320px" class="d-inline-flex flex-column justify-start">
    <v-form>

      <v-card-text v-if="$route.query['text']">
        {{ $route.query['text'] }}
      </v-card-text>
      <v-btn @click="close">
        OK
      </v-btn>
      <br>
      <br>
    </v-form>
  </v-sheet>

</template>

<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';
import {closeWidget} from "@/utils";

@Component
export default class Success extends Vue {
  close = closeWidget
}
</script>
